'use strict';

import React from 'react';
import PropTypes from 'prop-types';

export const LatestListingsError = ({ onRetry }) => (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-[60px] tw-gap-[16px]">
        <span className="tw-text-[16px] tw-text-gray-600">
            Unable to load listings at this time.
        </span>
        {onRetry && (
            <button
                onClick={onRetry}
                className={[
                    'tw-px-[20px] tw-py-[10px]',
                    'tw-border-[2px] tw-border-primary-500',
                    'tw-text-primary-500 tw-font-[600] tw-text-[14px]',
                    'tw-bg-transparent tw-cursor-pointer',
                    'hover:tw-bg-primary-500 hover:tw-text-white',
                    'tw-transition-all tw-duration-200'
                ].join(' ')}
            >
                Try Again
            </button>
        )}
    </div>
);

LatestListingsError.propTypes = {
    onRetry: PropTypes.func
};
